var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 229,
    viewBox: "0 0 229 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6629_14691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.259 190.347H105.734V229H123.259V190.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9887 175.803L49.6621 209.278L64.8387 218.04L84.1653 184.566L68.9887 175.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4362 144.84L10.9617 164.167L19.7239 179.344L53.1985 160.017L44.4362 144.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6531 105.734H0V123.259H38.6531V105.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.719 49.6612L10.9568 64.8379L44.4313 84.1644L53.1936 68.9878L19.719 49.6612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8458 10.9614L49.6692 19.7236L68.9957 53.1982L84.1724 44.436L64.8458 10.9614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.265 0H105.741V38.6531H123.265V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.165 10.9624L144.839 44.437L160.015 53.1993L179.342 19.7247L164.165 10.9624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.277 49.6593L175.802 68.9858L184.564 84.1625L218.039 64.8359L209.277 49.6593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 105.741H190.347V123.266H229V105.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.566 144.838L175.804 160.015L209.279 179.341L218.041 164.165L184.566 144.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.014 175.809L144.837 184.571L164.164 218.046L179.341 209.284L160.014 175.809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6629_14691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 229,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleProgress);
export default __webpack_public_path__ + "static/media/circle_progress.e4d9920d812b07fbe23a6e21c072d3a5.svg";
export { ForwardRef as ReactComponent };